// extracted by mini-css-extract-plugin
module.exports = {"bigStatTitle":"BigStat_bigStatTitle__10p9g","dropdown":"BigStat_dropdown__3kU2I"};